import { render, staticRenderFns } from "./MenuContext.vue?vue&type=template&id=a21c5560&scoped=true&"
import script from "./MenuContext.vue?vue&type=script&lang=js&"
export * from "./MenuContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21c5560",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemAvatar,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21c5560')) {
      api.createRecord('a21c5560', component.options)
    } else {
      api.reload('a21c5560', component.options)
    }
    module.hot.accept("./MenuContext.vue?vue&type=template&id=a21c5560&scoped=true&", function () {
      api.rerender('a21c5560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuContext.vue"
export default component.exports